/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIReportChartType } from '@/models/api/report-chart-type.model'

const resource = {
    main: 'services',
    module: 'report-chart-types'
}
export class ReportChartTypesServices {
    public static getReportChartTypes () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getReportChartTypesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getReportChartTypesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createReportChartTypes (params: APIReportChartType) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editReportChartTypes (params: APIReportChartType) {
        return service.put(`${resource.main}/${resource.module}/${params.chartTypeId}`, params)
    }

    public static deleteReportChartTypes (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
